import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { inputCls, btnPrimary, btnGhost, egp, orderLabel } from "@/lib/labels";

const OPTIONS = [
  { pct: 100, label: "إلغاء واسترداد 100%" },
  { pct: 50, label: "إلغاء واسترداد 50%" },
  { pct: 0, label: "إلغاء من غير استرداد (0%)" },
];

export const refundOf = (o, pct) => (o.is_free ? 0 : Math.floor((o.price * pct) / 100));

export const CancelOrderDialog = ({ order, onClose, onConfirm }) => {
  const [pct, setPct] = useState(100);
  const [reason, setReason] = useState("");
  const [review, setReview] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setPct(100); setReason(""); setReview(false); }, [order?.id]);
  if (!order) return null;
  const amount = refundOf(order, pct);
  const confirm = async () => {
    setBusy(true);
    try { await onConfirm(reason.trim(), pct); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent dir="rtl" className="border-purple-500/30 bg-[var(--km-bg2)] text-white" data-testid="cancel-order-dialog">
        <DialogHeader className="text-right sm:text-right"><DialogTitle className="font-display text-2xl">إلغاء {orderLabel(order)}</DialogTitle></DialogHeader>
        <p className="text-sm text-purple-200/80" data-testid="cancel-paid-amount">المدفوع فعلاً: {order.is_free ? "مجاني (مكافأة)" : egp(order.price)}</p>
        {!review ? (
          <form onSubmit={(e) => { e.preventDefault(); setReview(true); }} className="space-y-4">
            <div className="space-y-2" role="radiogroup">
              {OPTIONS.map((op) => (
                <label key={op.pct} className={`flex cursor-pointer items-center justify-between gap-3 rounded-2xl border p-3 ${pct === op.pct ? "border-[var(--km-pink)] bg-[var(--km-pink)]/10" : "border-purple-500/25 bg-black/30"}`} data-testid={`cancel-option-${op.pct}`}>
                  <span className="flex items-center gap-2"><input type="radio" name="refund" checked={pct === op.pct} onChange={() => setPct(op.pct)} className="accent-[var(--km-pink)]" />{op.label}</span>
                  <span className="font-head font-bold text-[var(--km-cyan)]">{order.is_free ? (op.pct === 100 ? "ترجع المكافأة" : "المكافأة مش هترجع") : egp(refundOf(order, op.pct))}</span>
                </label>
              ))}
            </div>
            <label className="block">
              <span className="mb-1 block text-sm font-bold">سبب الإلغاء (هيوصل للعميل)</span>
              <textarea className={`${inputCls} min-h-[90px]`} value={reason} onChange={(e) => setReason(e.target.value)} required minLength={3} maxLength={300} data-testid="cancel-order-dialog-input" />
            </label>
            <button type="submit" className={btnPrimary} data-testid="cancel-order-review">مراجعة الإلغاء</button>
          </form>
        ) : (
          <div className="space-y-4" data-testid="cancel-order-summary">
            <div className="space-y-1 rounded-2xl bg-black/30 p-4 text-sm">
              <p>نسبة الاسترداد: <b data-testid="cancel-summary-pct">{pct}%</b></p>
              <p>المبلغ اللي هيرجع لمحفظة العميل على الموقع: <b data-testid="cancel-summary-amount">{order.is_free ? (pct === 100 ? "ترجع المكافأة" : "0") : egp(amount)}</b></p>
              <p>السبب: {reason}</p>
              <p className="text-xs text-purple-300/70">الاسترداد بيتم لمحفظة الموقع بس، مش فودافون كاش أو إنستاباي.</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <button type="button" disabled={busy} onClick={confirm} className={btnPrimary} data-testid="cancel-order-dialog-confirm">{busy && <Loader2 className="h-4 w-4 animate-spin" />} تأكيد الإلغاء</button>
              <button type="button" disabled={busy} onClick={() => setReview(false)} className={btnGhost} data-testid="cancel-order-back">رجوع</button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
